namespace $ {
	export class $shm_hitalama_chat_room_personal extends $giper_baza_entity.with({

		Draft_message: $giper_baza_text,

	}){
		
		draft_message( next?: string ) {
			return this.Draft_message(next)?.value(next) ?? ''
		}
		
	}
}
